<c11n-modal-dialog
  #confirmationModal
  [variant]="variant"
  [headingText]="headingText"
  (closeEvent)="onClose()"
>
  <div c11n-modal-dialog-body>
    <!-- Body text at top -->
    <div *ngIf="bodyText" class="mb-3">
      <p class="mb-0">{{bodyText}}</p>
    </div>

    <!-- Buttons below -->
    <div class="d-flex flex-column-reverse flex-md-row gap-2 justify-content-start">
      <c11n-button
        [labelText]="confirmButtonText"
        [variant]="confirmButtonVariant"
        (clickEvent)="onConfirm()"
      ></c11n-button>

      <c11n-button
        [labelText]="cancelButtonText"
        variant="secondary"
        (clickEvent)="onCancel()"
      ></c11n-button>
    </div>
  </div>
</c11n-modal-dialog>
